import styled from 'styled-components';

/* Rząd ikon integracji — jedna ikona = jeden zewnętrzny system.
   Kolejne integracje (np. inne PMS-y) dokładamy tu bez zmian w layoucie. */
export const TileGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

/* Kafelek to samo logo na tle w kolorze marki. Nazwa jest w tooltipie, status w kolorze:
   wyłączona integracja jest szara (grayscale), żeby od razu odróżniała się od działających. */
export const Tile = styled.button<{ $accent: string; $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  padding: 0;
  cursor: pointer;
  border: none;
  border-radius: 12px;
  background: ${({ $accent }) => $accent};
  filter: ${({ $active }) => ($active ? 'none' : 'grayscale(1)')};
  opacity: ${({ $active }) => ($active ? 1 : 0.55)};
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    opacity: ${({ $active }) => ($active ? 1 : 0.75)};
  }

  &:focus-visible {
    outline: 2px solid #111827;
    outline-offset: 2px;
  }

  svg,
  img {
    display: block;
    width: 40px;
    height: 40px;
  }
`;
